export enum GatewayStatus {
  notMonitored = 'NotMonitored',
  online = 'Online',
  offline = 'Offline',
  passiveOfflineOnly = 'PassiveOfflineOnly',
  serviceOfflineOnly = 'ServiceOfflineOnly',
}
